import React from 'react';
import logo from './logo.svg';
import './App.css';
import { isMobile } from './utils/helper';
import Footer from './components/footer/Footer';
import { Route, Routes } from 'react-router-dom';
import Home from './pages/Home/Home';
import MapSelector from './pages/MapSelector/MapSelector';

function App() {
  return (
    <div>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path='/location' element={<MapSelector />} />
      </Routes>
      {
        isMobile() && <Footer />
      }
    </div>
  );
}

export default App;
